<div class="w-full max-w-none">
  <form [formGroup]="bookingForm" (ngSubmit)="onSubmit()">
    <div class="flex justify-start items-center space-x-3">
      <div class="text-xl font-bold">
        {{ data?.booking?._id ? "Update Booking" : "New Booking" }}
      </div>
      <div *ngIf="selectedCourt" class="text-xl font-bold">-</div>
      <div
        *ngIf="sportsData"
        class="sport-logo-container"
        [style.background-color]="getSportsColor()"
      >
        <img [src]="getSportsLogo()" alt="Sport Logo" class="sport-logo" />
      </div>
      <div *ngIf="selectedCourt" class="inline-block text-xl font-bold">
        {{ getSportDisplayName(selectedCourt?.sports) }}
      </div>
    </div>
    <div class="mt-5 border-t"></div>
    <div class="grid w-full sm:grid-cols-10">
      <div class="col-span-6 mt-6 pr-5">
        <div class="sm:col-span-3 flex items-center gap-5">
          <mat-form-field class="w-50">
            <mat-label>Select Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControlName]="'start'"
              [min]="today"
              (dateChange)="onDateChange($event)"
            />
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <ng-container *ngIf="isMaintenanceSelected(); else bookingSlots">
            <mat-form-field class="w-32">
              <mat-label>Start time</mat-label>
              <input
                matInput
                [matTimepicker]="timePicker"
                [formControlName]="'start'"
                (timeChange)="onTimeChange($event)"
                [disabled]="isCompleteDaySelected()"
              />
              <mat-timepicker-toggle matIconSuffix [for]="timePicker" />
              <mat-timepicker #timePicker />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Duration</mat-label>
              <mat-select
                [formControlName]="'duration'"
                (selectionChange)="durationChange($event)"
              >
                <mat-option value="30">30 mins</mat-option>
                <mat-option value="60">60 mins</mat-option>
                <mat-option value="90">90 mins</mat-option>
                <mat-option value="120">120 mins</mat-option>
                <mat-option value="completeDay">Complete Day</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-template #bookingSlots>
            <mat-form-field class="w-40">
              <mat-label>Available time slot</mat-label>
              <mat-select
                [value]="selectedAvailabilityStart"
                [disabled]="isLoadingAvailability"
                (selectionChange)="selectAvailabilitySlot($event.value)"
              >
                <mat-option
                  *ngFor="let slot of availabilitySlots"
                  [value]="slotKey(slot)"
                  [disabled]="!isAvailabilitySlotSelectable(slot)"
                >
                  {{ formatAvailabilitySlot(slot) }}
                  {{
                    isAvailabilitySlotSelectable(slot) ? "" : "— Unavailable"
                  }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="isLoadingAvailability">Loading slots…</mat-hint>
              <mat-hint *ngIf="!isLoadingAvailability && availabilityError">
                {{ availabilityError }}
              </mat-hint>
              <mat-hint
                *ngIf="
                  !isLoadingAvailability &&
                  !availabilityError &&
                  availabilitySlots.length === 0
                "
              >
                No time slots are available for this date.
              </mat-hint>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Duration</mat-label>
              <mat-select
                [formControlName]="'duration'"
                [disabled]="!selectedAvailabilityStart"
                (selectionChange)="durationChange($event)"
              >
                <mat-option
                  *ngFor="let minutes of availableDurationOptions"
                  [value]="minutes.toString()"
                >
                  {{ minutes }} mins
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </div>
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
          <span class="font-large font-semibold ml-4">
            {{ getFormattedDate() }}
          </span>
        </div>
        <div class="mt-3">
          <button mat-flat-button disabled class="px-10 py-2">
            {{ getStartTime() }}
          </button>
          <mat-icon class="pt-4" svgIcon="heroicons_outline:minus"></mat-icon>
          <button mat-flat-button disabled class="px-10 py-2">
            {{ getEndTime() }}
          </button>
        </div>

        <!-- Court Operating Hours Warning -->
        <div
          *ngIf="
            isMaintenanceSelected() &&
            isCompleteDaySelected() &&
            courtOperatingHours
          "
          class="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded-md"
        >
          <div class="flex items-center">
            <mat-icon
              class="text-yellow-600 mr-2"
              svgIcon="heroicons_outline:information-circle"
            ></mat-icon>
            <div class="text-sm text-yellow-700">
              Complete day maintenance will cover:
              {{ courtOperatingHours.startTime }} to
              {{ courtOperatingHours.endTime }}
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-5 mt-4">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Venue</mat-label>
            <mat-select
              [formControlName]="'venueId'"
              (selectionChange)="fetchCourts($event)"
            >
              <mat-option *ngFor="let venue of venues" [value]="venue._id">
                {{ venue.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                bookingForm.get('venueId')?.hasError('required') &&
                bookingForm.get('venueId')?.touched
              "
              >Venue is required.</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Court</mat-label>
            <mat-select
              [formControlName]="'courtId'"
              (selectionChange)="selectCourt($event)"
            >
              <mat-option [value]="''">Select Court</mat-option>
              <mat-option *ngFor="let court of courts" [value]="court._id">
                {{ court.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                bookingForm.get('courtId')?.hasError('required') &&
                bookingForm.get('courtId')?.touched
              "
              >Court is required.</mat-error
            >
          </mat-form-field>
        </div>

        <div class="grid grid-cols-2 gap-4 mt-4">
          <div class="sm:col-span-1">
            <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
              <mat-label>Booking Status</mat-label>
              <mat-icon
                class="icon-size-3"
                [style.color]="
                  bookingForm.get('status')?.value === 'confirmed'
                    ? '#2E9B11'
                    : '#F33779'
                "
                [svgIcon]="'mat_solid:circle'"
                matPrefix
              ></mat-icon>
              <mat-select
                [formControlName]="'status'"
                (selectionChange)="onStatusChange($event)"
              >
                <mat-option [value]="'tentative'">Tentative</mat-option>
                <mat-option [value]="'confirmed'">Confirmed</mat-option>
                <mat-option [value]="'completed'">Completed</mat-option>
                <mat-option
                  *ngIf="data?.booking?.status === 'maintenance'"
                  [value]="'maintenance'"
                >
                  Legacy Maintenance
                </mat-option>
                <mat-option [value]="'canceled'">Canceled</mat-option>
                <mat-option [value]="'no_show'">No Show</mat-option>
                <mat-option [value]="'expired'">Expired</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <app-venue-booking-match-settings
          [form]="bookingForm"
          [court]="selectedCourt"
          [sport]="sportsData?.key || bookingForm.get('sports')?.value"
          [formats]="sportsData?.matchFormats || []"
          [maintenance]="isMaintenanceSelected()"
          [occupiedPlayerSlots]="displayedParticipants.length"
          [showMatchmakingToggle]="!savedBookingId && isAdmin"
        ></app-venue-booking-match-settings>

        <div
          class="flex justify-between font-large mt-6 p-3 bg-payment"
          *ngIf="!isMaintenanceSelected()"
        >
          <div class="font-semibold">Payment</div>
          <div>
            <span class="font-semibold">{{
              formatAedCurrency(totalPrice)
            }}</span>
          </div>
        </div>
        <div
          class="flex justify-between font-large mt-6 p-3 bg-gray-100"
          *ngIf="isMaintenanceSelected()"
        >
          <div class="font-semibold">Maintenance Mode</div>
          <div>
            <span class="font-semibold">{{ formatAedCurrency(0) }}</span>
          </div>
        </div>

        <div class="mt-4">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Notes (optional)</mat-label>
            <textarea
              matInput
              formControlName="notes"
              rows="3"
              maxlength="500"
              placeholder="Add any special requests or details..."
            ></textarea>
            <mat-hint align="end">
              {{ bookingForm.get("notes")?.value?.length || 0 }}/500
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="col-span-4 pl-5 pt-6" style="border-left: 1px solid #ddd">
        <div class="mb-2 font-semibold">Participants</div>

        <!-- Add Player Options - Buttons -->
        <div class="mb-4">
          <div class="flex gap-2 mb-4">
            <button
              mat-stroked-button
              type="button"
              class="flex-1 min-h-[48px] whitespace-normal break-words py-2"
              (click)="showExistingPlayers = true; showNewPlayerForm = false"
              [color]="showExistingPlayers ? 'primary' : ''"
              [disabled]="isMaintenanceSelected()"
            >
              <div class="flex flex-col items-center justify-center">
                <mat-icon class="mb-1">people</mat-icon>
                <span class="text-xs leading-tight"
                  >Choose Existing Player</span
                >
              </div>
            </button>
            <button
              mat-stroked-button
              type="button"
              class="flex-1 min-h-[48px] whitespace-normal break-words py-2"
              (click)="showExistingPlayers = false; showNewPlayerForm = true"
              [color]="showNewPlayerForm ? 'primary' : ''"
              [disabled]="isMaintenanceSelected()"
            >
              <div class="flex flex-col items-center justify-center">
                <mat-icon class="mb-1">person_add</mat-icon>
                <span class="text-xs leading-tight">Add New Player</span>
              </div>
            </button>
          </div>

          <!-- Venue-history player picker -->
          <div *ngIf="showExistingPlayers" class="mt-2">
            <app-venue-player-picker
              [venueId]="bookingForm.get('venueId')?.value"
              [excludedPlayerIds]="excludedPlayerIds"
              [disabled]="isMaintenanceSelected()"
              (playerSelected)="addPlayer($event)"
            />
          </div>

          <!-- New Player Form -->
          <div *ngIf="showNewPlayerForm" class="mt-2">
            <form [formGroup]="manualPlayerForm" class="space-y-3">
              <mat-form-field class="w-full">
                <mat-label>Full Name</mat-label>
                <input
                  matInput
                  formControlName="name"
                  placeholder="Enter player's full name"
                  [disabled]="isMaintenanceSelected()"
                />
                <mat-error
                  *ngIf="manualPlayerForm.get('name')?.hasError('required')"
                >
                  Name is required
                </mat-error>
                <mat-error
                  *ngIf="manualPlayerForm.get('name')?.hasError('minlength')"
                >
                  Name must be at least 2 characters
                </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="email"
                  type="email"
                  placeholder="Enter player's email"
                  [disabled]="isMaintenanceSelected()"
                />
                <mat-error
                  *ngIf="manualPlayerForm.get('email')?.hasError('required')"
                >
                  Email is required
                </mat-error>
                <mat-error
                  *ngIf="manualPlayerForm.get('email')?.hasError('email')"
                >
                  Please enter a valid email
                </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Phone</mat-label>
                <input
                  matInput
                  formControlName="phone"
                  placeholder="Enter player's phone number"
                  [disabled]="isMaintenanceSelected()"
                />
                <mat-error
                  *ngIf="manualPlayerForm.get('phone')?.hasError('required')"
                >
                  Phone number is required
                </mat-error>
              </mat-form-field>

              <button
                mat-flat-button
                color="primary"
                class="w-full"
                (click)="createPlayerManually()"
                [disabled]="
                  manualPlayerForm.invalid ||
                  isCreatingPlayer ||
                  isMaintenanceSelected()
                "
              >
                <mat-progress-spinner
                  *ngIf="isCreatingPlayer"
                  diameter="20"
                  mode="indeterminate"
                  class="mr-2"
                ></mat-progress-spinner>
                {{ isCreatingPlayer ? "Creating..." : "Create & Add Player" }}
              </button>
            </form>
          </div>
        </div>

        <!-- Selected Participants List -->
        <div class="mb-2">
          <div class="text-sm text-gray-600">
            Selected Participants ({{ displayedParticipants.length }})
          </div>
        </div>

        <div
          *ngFor="let player of displayedParticipants"
          class="border rounded-lg py-2 px-4 flex items-center mt-2 bg-gray-50"
        >
          <!-- Avatar with fallback to first letter -->
          <div
            class="mr-4 h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center text-sm font-semibold text-gray-700"
            *ngIf="!player.avatar; else avatarImage"
          >
            {{ player.name?.charAt(0)?.toUpperCase() }}
          </div>
          <ng-template #avatarImage>
            <img
              class="mr-4 h-10 w-10 rounded-full"
              [src]="player.avatar"
              alt="{{ player.name }}"
            />
          </ng-template>
          <div class="flex flex-col flex-1">
            <span class="font-semibold leading-none">{{ player.name }}</span>
            <span class="mt-1 text-xs text-gray-500">{{ player.status }}</span>
          </div>
          <button
            *ngIf="player.removable"
            mat-stroked-button
            type="button"
            class="mr-2"
            [color]="organizerPlayerId === player._id ? 'primary' : ''"
            [attr.aria-pressed]="organizerPlayerId === player._id"
            [attr.aria-label]="'Set ' + player.name + ' as match organizer'"
            (click)="selectOrganizer(player._id)"
            [disabled]="isMaintenanceSelected()"
          >
            <mat-icon>{{
              organizerPlayerId === player._id ? "star" : "star_border"
            }}</mat-icon>
            {{
              organizerPlayerId === player._id ? "Organizer" : "Set organizer"
            }}
          </button>
          <button
            class="-mr-2 ml-auto"
            mat-icon-button
            (click)="removePlayer(player._id)"
            *ngIf="player.removable"
            [disabled]="isMaintenanceSelected()"
          >
            <mat-icon
              class="text-gray-500 icon-size-4"
              [svgIcon]="'heroicons_solid:trash'"
            ></mat-icon>
          </button>
        </div>

        <!-- Empty state -->
        <div
          *ngIf="displayedParticipants.length === 0"
          class="text-center text-gray-500 py-6 border-2 border-dashed rounded-lg mt-2"
        >
          <mat-icon class="text-gray-400 mb-2">people</mat-icon>
          <div class="text-sm">No participants added yet</div>
          <div class="text-xs mt-1">Use the buttons above to add players</div>
        </div>
        <div
          *ngIf="selectedPlayers.length > 0"
          class="mt-2 text-xs text-gray-500"
        >
          If you do not select an organizer, the first player to accept will
          become the organizer.
        </div>
      </div>
    </div>

    <app-venue-matchmaking-trigger
      *ngIf="savedBookingId && isAdmin"
      [bookingId]="savedBookingId"
      [bookingType]="bookingForm.get('bookingType')?.value"
    ></app-venue-matchmaking-trigger>

    <div
      *ngIf="globalError"
      class="bk-alert-wrap"
      role="alert"
      aria-live="assertive"
    >
      <div class="bk-alert bk-alert-error">
        <mat-icon
          class="bk-alert-icon"
          svgIcon="heroicons_outline:exclamation-triangle"
        ></mat-icon>

        <div class="bk-alert-body">
          <div class="bk-alert-msg">{{ globalError }}</div>
        </div>

        <button
          type="button"
          class="bk-alert-close"
          mat-icon-button
          (click)="dismissGlobalError()"
          aria-label="Dismiss error"
        >
          <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
      </div>
    </div>

    <div class="mb-5 mt-5 border-t"></div>
    <div class="flex items-center justify-end">
      <button
        class="ml-4 pr-20 pl-20"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="bookingForm.invalid || isLoading"
      >
        Save
      </button>
    </div>
  </form>
</div>
